import { useEffect, useRef, useState } from 'react';
import { EquipmentDmgFilterType } from '@/entities/equipment';
import { useLocalStorageState } from '../local-storage.hooks';
import debounce from 'lodash/debounce';
import { RepairCostingLocalStorage } from '@/entities/repair-costing';

interface RepairCostingFilterProps {
  setCurrentPage: (page: number) => void;
}

export const useRepairCostingFilter = ({ setCurrentPage }: RepairCostingFilterProps) => {
  const [debouncedFilter, setDebouncedFilter] =
    useState<EquipmentDmgFilterType>({
      key: '',
    });
  const filtersEmptyRef = useRef<boolean>(true);

  const [key, setKey] = useLocalStorageState({
    key: RepairCostingLocalStorage.KEY,
    removeOnClose: true,
  });

  const [status, setStatus] = useLocalStorageState({
    key: RepairCostingLocalStorage.STATUS,
    removeOnClose: true,
  });

  useEffect(() => {
    setDebouncedFilter((prev) => ({
      ...prev,
      key: key || '',
      status,
    }));

    filtersEmptyRef.current = !key && !status;
  }, [key, status]);

  const debounceFilterUpdate = (value: string) => {
    setKey(value);
    debounce((value: string) => {
      setDebouncedFilter((prev) => ({ ...prev, key: value }));
    }, 1000);
  };

  const searchByStatus = (value: string) => {
    setStatus(value);
    setDebouncedFilter((prev) => ({ ...prev, status: value }));
  };

  const clearFilters = () => {
    setKey('');
    setStatus('');
    setCurrentPage(1);
  };

  return {
    debouncedFilter,
    filtersEmpty: filtersEmptyRef.current,
    clearFilters,
    key,
    status,
    debounceFilterUpdate,
    searchByStatus,
  };
};
